<template>
  <div class="PaymentLogo">
    <ul class="PaymentLogo-container">
      <li>
        <svg v-svg symbol="Visa" size="0 0 29 20" role="presentation" class="icon--inline"></svg>
      </li>
      <li>
        <svg
          v-svg
          symbol="MasterCard"
          size="0 0 29 20"
          role="presentation"
          class="icon--inline"
        ></svg>
      </li>
      <li>
        <svg v-svg symbol="AMEX" size="0 0 29 20" role="presentation" class="icon--inline"></svg>
      </li>
      <li>
        <svg v-svg symbol="PayPal" size="0 0 29 20" role="presentation" class="icon--inline"></svg>
      </li>
    </ul>
  </div>
</template>

<script>

import "@/components/Payment/PaymentLogo/PaymentLogo.scss";

export default {
  name: "PaymentLogo",
};
</script>
